<script lang="ts">
  export let content: { title?: string; subTitle?: string };
</script>

<section class="brand-story-title">
  {#if content?.title}
    <h4>{content.title}</h4>
  {/if}

  {#if content?.subTitle}
    <span>{content.subTitle}</span>
  {/if}
</section>

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .brand-story-title {
    display: flex;
    flex-direction: column;
    color: $neutral-dark-01;
    h4 {
      font-weight: 700;
      font-size: 16px;
      line-height: 41px;
      margin: 0;
      @include desktop-min-width {
        font-size: 38px;
      }
    }
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      @include desktop-min-width {
        font-size: 24px;
        line-height: 41px;
      }
    }
  }
</style>
